module.exports = __webpack_public_path__ + "static/media/team.3932d32b.png";